/**
 * TasksDefaultRedirect - Redirecionamento inteligente para o módulo de Tarefas
 * 
 * Detecta o primeiro menu de tarefas que o usuário tem permissão
 * e redireciona automaticamente, evitando tela de "Acesso Negado".
 * 
 * @version 1.0.0
 * RELEASE: 2026-04-07 v1.0.0 - Redirecionamento baseado em permissões
 */

import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { Loader2 } from 'lucide-react';

/** Ordem de prioridade das rotas do módulo Tarefas */
const TASKS_ROUTE_PRIORITY = [
  { key: 'tasks_dashboard', path: '/tenant/tasks/dashboard' },
  { key: 'tasks_kanban', path: '/tenant/tasks/kanban' },
  { key: 'tasks_list', path: '/tenant/tasks/list' },
  { key: 'tasks_categories', path: '/tenant/tasks/categories' },
  { key: 'tasks_phases', path: '/tenant/tasks/phases' },
  { key: 'tasks_classifications', path: '/tenant/tasks/classifications' },
] as const;

export default function TasksDefaultRedirect() {
  const { canView, loading } = usePermissions();

  // Aguarda carregamento das permissões
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  // Redireciona para a primeira rota permitida
  const firstAllowed = TASKS_ROUTE_PRIORITY.find(route => canView(route.key));

  if (firstAllowed) {
    return <Navigate to={firstAllowed.path} replace />;
  }

  // Sem permissão em nenhum menu de tarefas — volta para conversas
  return <Navigate to="/tenant" replace />;
}
